import {
  Box,
  Divider,
  Grid,
  Paper,
  Toolbar,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Tooltip,
  Skeleton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import { userSelector } from "../../user-redux/selector";
import LoadingSkeleton from "../../loadingSkeletons/LoadingList";
import AdminInactiveRecruitersList from "./AdminInactiveRecruitersList";
import {
  getMyInactiveRecruitersAction,
  selectedRecruiterAction,
  updateRecruiterStatusAction,
} from "../../redux/action";
import { useNavigate } from "react-router";
import imageSrc from "../../images/Nocandidate.png";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";

const Admininactive = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { inactiveRecruiters, selectedRecruiter } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const [noRecruiterFound, setNorecruitersFound] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [loadingInactiveRecruiters, setLoadingInactiveRecruiters] = useState(false);
  const [selectedRecruiters, setSelectedRecruiters] = useState([]);

  const inactiveRec = inactiveRecruiters?.length === 0;
  //console.log(inactiveRecruiters, "inactiveRecruiters")
  useEffect(() => {
    const fetchData = async () => {
      setNorecruitersFound(false);   // Reset dialog
      setLoadingInactiveRecruiters(true);

      const companyId = user?.companyid === 0 ? 1 : user?.companyid;

      const adminData = {
        company_id: companyId,
      };

      const response = await dispatch(getMyInactiveRecruitersAction(adminData));

      if (response?.data?.[0]?.recruiter_uid > 0) {
        dispatch(selectedRecruiterAction(response.data[0]));
      } else {
        dispatch(selectedRecruiterAction(null));
        setNorecruitersFound(true);
      }

      setLoadingInactiveRecruiters(false);
    };
    fetchData();
  }, [dispatch, user?.id]);

  const handleCloseDialog = () => {
    setNorecruitersFound(false);
    navigate("/admin-dashboard");
  };

  const topBarStyles = {
    padding: "10px",
    borderRadius: "4px",
    margin: "5px 5px 0px 5px",
    border: "none",
  };

  const paperStyles = {
    borderRadius: "8px",
    overflow: "scroll",
  };

  useEffect(() => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => setImageLoaded(true);
  }, []);

  // useEffect(() => {
  //   return () => {
  //     dispatch(selectedRecruiterAction(null));
  //   };
  // }, []);

  useEffect(() => {
    console.log(inactiveRecruiters.length, "inactiveRecruiters");
    console.log(loadingInactiveRecruiters, "loadingInactiveRecruiters");
    if (inactiveRecruiters.length === 0 && !loadingInactiveRecruiters) {
      dispatch(selectedRecruiterAction(null));
      //setNorecruitersFound(true);
    }
  }, [inactiveRecruiters, loadingInactiveRecruiters, dispatch]);

  useEffect(() => {
    if (
      inactiveRecruiters.length > 0 &&
      (!selectedRecruiter ||
        !inactiveRecruiters.some(
          (r) => r.recruiter_uid === selectedRecruiter.recruiter_uid
        ))
    ) {
      // Select the new first recruiter if the current one is missing
      dispatch(selectedRecruiterAction(inactiveRecruiters[0]));
    }
  }, [inactiveRecruiters, selectedRecruiter, dispatch]);

  const handleMoveToActive = async () => {
    const updatedData = {
      status: 1,
      recruiter_ids: selectedRecruiters,
    };

    const rec_data = {
      company_id: user?.companyid,
    };

    const response = await dispatch(
      updateRecruiterStatusAction(updatedData, rec_data, "inactive")
    );

    setSelectedRecruiters([]);

    if (response?.data?.length === 0) {
      setNorecruitersFound(true);
    } else {
      setNorecruitersFound(false);
    }
  };

  return (
    <Box sx={{ pt: 1, px: 1, mx: { xs: -1, md: -2 }, height: "calc(100vh - 67px)", display: "flex", flexDirection: "column", bgcolor: "#F8F8F8", position: "relative" }}>
      <Grid container spacing={1} sx={{ flex: 1, minHeight: 0 }}>
        <Grid item xs={12} md={3} sx={{ height: "100%" }}>
          {(inactiveRecruiters?.length > 0 || loadingInactiveRecruiters) && <Paper elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
            <Toolbar
              sx={{
                minHeight: "42px !important",
                pl: 2,
                pr: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: 500 }}>
                Inactive Recruiters
              </Typography>

              <Tooltip title="Move To Active">
                <DriveFileMoveOutlinedIcon
                  style={{ color: "gray", cursor: selectedRecruiters.length > 0 ? "pointer" : "not-allowed" }}
                  onClick={handleMoveToActive}
                />
              </Tooltip>


            </Toolbar>
            <Divider sx={{ margin: 0 }} />
            <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
              {loadingInactiveRecruiters ? (
                <LoadingSkeleton />
              ) : (
                <AdminInactiveRecruitersList
                  setNorecruitersFound={setNorecruitersFound}
                  selectedRecruiters={selectedRecruiters}
                  setSelectedRecruiters={setSelectedRecruiters}
                />
              )}
            </Box>
          </Paper>}
        </Grid>
        <Grid item xs={12} md={9} sx={{ height: "100%" }}>
          {(inactiveRecruiters?.length > 0 || loadingInactiveRecruiters) && <Paper elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
            <Toolbar
              sx={{
                minHeight: "42px !important",
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
              }}
            >
              <Typography
                sx={{ fontWeight: 500, margin: 0 }}
                paragraph
                id="tableTitle"
                component="div"
              >
                Profile View
              </Typography>
            </Toolbar>
            <Divider sx={{ margin: 0 }} />
            <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0, p: 2 }}>
              {loadingInactiveRecruiters ? (
                <Box sx={{ p: 2 }}>
                  {/* Name */}
                  <Skeleton variant="text" width="35%" height={40} sx={{ mb: 2 }} />
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <Skeleton variant="text" width="22%" height={30} />
                    <Skeleton variant="text" width="35%" height={30} />
                    <Skeleton variant="text" width="20%" height={30} />
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  <Box
                    sx={{
                      p: 2,
                      border: "1px solid #e0e0e0",
                      borderRadius: "5px",
                    }}
                  >
                    <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
                    <Skeleton variant="rounded" width="100%" height={120} />
                    <Skeleton
                      variant="rounded"
                      width={100}
                      height={36}
                      sx={{ mt: 2 }}
                    />
                  </Box>
                </Box>
              ) : inactiveRecruiters.length === 0 ? (
                <Box sx={{ p: 2, display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    No inactive recruiters available.
                  </Typography>
                </Box>
              ) : selectedRecruiter?.recruiter_uid ? (
                <Box sx={{ padding: "10px" }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                    {selectedRecruiter.recruiter_name}
                  </Typography>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
                  >
                    <Typography variant="subtitle1">
                      Role: {selectedRecruiter.role}
                    </Typography>
                    <Typography variant="subtitle1">
                      Email: {selectedRecruiter.recruiter_email}
                    </Typography>
                    {selectedRecruiter?.phone && selectedRecruiter.phone !== "" && (
                      <Typography variant="subtitle1">
                        Mobile: {selectedRecruiter.phone}
                      </Typography>
                    )}
                  </Box>
                  <Divider sx={{ mb: 2 }} />

                  {selectedItems?.length > 0 ? (
                    <Box
                      sx={{
                        p: 2,
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        marginTop: "10px",
                      }}
                    >
                      <Button variant="contained">Save</Button>
                    </Box>
                  ) : (
                    selectedRecruiter?.inactive_reason && (
                      <Box
                        sx={{
                          p: 2,
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          marginTop: "10px",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "grey", mb: 1 }}
                        >
                          Reason for inactive
                        </Typography>
                        <Typography variant="subtitle1">
                          {selectedRecruiter.inactive_reason}
                        </Typography>
                      </Box>
                    )
                  )}
                </Box>
              ) : (
                <Box sx={{ p: 2, display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    Select a candidate to view details
                  </Typography>
                </Box>
              )}
            </Box>
          </Paper>}
        </Grid>
      </Grid>
      <Dialog
        open={noRecruiterFound}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="xs"
        disablePortal
        disableScrollLock
        sx={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 10,
          "& .MuiBackdrop-root": {
            position: "absolute",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)"
          },
          "& .MuiDialog-container": {
            position: "absolute",
            top: 0, left: 0, right: 0, bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          "& .MuiDialog-paper": {
            width: "400px",
            margin: 0,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)"
          }
        }}
      >
        {imageLoaded ? (
          <>
            <DialogTitle sx={{ textAlign: "center" }}>
              <img
                src={imageSrc}
                alt="Placeholder"
                style={{
                  width: "100%",
                  objectFit: "contain",
                  borderRadius: "8px",
                  marginBottom: "8px",
                }}
              />
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1">
                No inactive recruiters data was found based on the current
                search criteria.
              </Typography>
            </DialogContent>
          </>
        ) : (
          <DialogContent>
            <Typography variant="body1">Loading.....</Typography>
          </DialogContent>
        )}
        <DialogActions>
          <Button
            onClick={handleCloseDialog}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Admininactive;
